import CTA from "./CTA";
import type { Props } from "./types";

export default function Badge(props: Props) {
	return <CTA badge colors="teal" size="xs" {...props} />;
}
